import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the AuthStore provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class FamilyStore {

  private _family:object;
  set family(family:object){
    this._family = family;
  }
  get family(){
    return this._family;
  }
}


// WEBPACK FOOTER //
// ./src/stores/family-store.ts